<template>
  <div>
    <appBarMobile
      color="primary"
      show-back-button
      :show-nav-icon="false"
      title="Privacy"
    />
    <span class="ma-0">
      <iframe
        style="width:100%;"
        src="https://education.nsw.gov.au/about-us/rights-and-accountability/privacy"
      />
    </span>
  </div>
</template>
<script>
  import appBarMobile from "@/components/appBarMobile";
  export default {
    components: {
      appBarMobile,
    }
  }
</script>

<style scoped>

</style>